import { render, staticRenderFns } from "./segment-column-category.vue?vue&type=template&id=04c3c99f&scoped=true&"
import script from "./segment-column-category.vue?vue&type=script&lang=js&"
export * from "./segment-column-category.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c3c99f",
  null
  
)

export default component.exports